import React, { Fragment, useState, useEffect } from "react";
import {
  Checkbox,
  Chip,
  Collapse,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import NumberFormat from "react-number-format";
import styles from "../../../styles/global-styles";
import StyleTableRow from "../../../styles/styleTableRow";
import StyledTableCell from "../../../styles/tableCell";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import {
  customDate,
  getBrandAndModel,
  getProductBarCode,
  getProductDiscount,
  getProductInfoSells,
  getProductPriceInSells,
  getProductType,
} from "../../../_utils/utils";

const useStyles = makeStyles(() => ({
  table: {
    minWidth: 700,
  },
  chip: styles.chip,
  successfulChip: styles.successfullChip,
  secondaryChip: styles.secondaryChip,
  body: styles.body,
  subtitle: styles.subtitle,
}));

const SellRow = ({ item, i, selectedProducts, clickCheckbox, typeOfSells }) => {
  const classes = useStyles();

  /**Check box options */
  const [selected, setSelected] = useState(selectedProducts);
  const [openCollapsible, setOpenCollapsible] = React.useState({
    index: null,
    open: false,
  });

  useEffect(() => {
    setSelected(selectedProducts);
  }, [selectedProducts]);

  const isSelected = (id) => selected.indexOf(id) !== -1;
  const isItemSelected = (row) => isSelected(row.id);

  const showPaymentMethodTotalProds = (value) => {
    if (typeof value === "string") {
      return value;
    } else {
      return (
        <span style={{ fontWeight: 800, fontSize: 16, color: "blue" }}>
          {value}
        </span>
      );
    }
  };

  const showProductType = (item) => {
    if (
      typeOfSells === "sellsBySite" &&
      typeof item.payment_method?.name === "number"
    ) {
      return `${getProductType(item.product?.productTypeId)}   (${
        item.payment_method?.name
      })`;
    } else return getProductType(item.product?.productTypeId);
  };

  return (
    <Fragment key={i}>
      <StyleTableRow className={classes.row}>
        {typeOfSells === "sellsByUser" && (
          <StyledTableCell padding="checkbox">
            <Checkbox
              checked={isItemSelected(item)}
              onClick={() => clickCheckbox(item)}
              color="primary"
            />
          </StyledTableCell>
        )}
        <StyledTableCell>
          {item.product.chip && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() =>
                setOpenCollapsible({
                  ...openCollapsible,
                  index: i,
                  open: !openCollapsible.open,
                })
              }
            >
              {openCollapsible.open && openCollapsible.index === i ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          )}
        </StyledTableCell>
        <StyledTableCell align="center">
          <Chip label={showProductType(item)} className={classes.chip} />
        </StyledTableCell>
        <StyledTableCell align="center">
          {getBrandAndModel(item, false)}
        </StyledTableCell>
        <StyledTableCell align="center" style={{ fontWeight: 600 }}>
          {getProductInfoSells(item)}
        </StyledTableCell>
        <StyledTableCell align="center">
          {getProductBarCode(item)}
        </StyledTableCell>
        <StyledTableCell align="center">
          <Chip
            label={
              <NumberFormat
                value={getProductPriceInSells(item)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            }
            className={classes.successfulChip}
          />
        </StyledTableCell>
        <StyledTableCell align="center">
          <NumberFormat
            value={getProductDiscount(item)}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
          />
        </StyledTableCell>

        <StyledTableCell
          align="center"
          style={{ fontWeight: typeOfSells === "sellsByUser" ? "normal" : 600 }}
        >
          {typeOfSells === "sellsByUser"
            ? showPaymentMethodTotalProds(item.payment_method?.name)
            : item.user?.name}
        </StyledTableCell>

        <StyledTableCell align="center">
          {/** TODO apuntar a base de prod
           * & cambiar por updatedAt
           */}
          {customDate(item.createdAt)}
        </StyledTableCell>
        <StyledTableCell align="center" style={{ fontWeight: 700 }}>
          {/* <Chip
    label={item.factureCreated ? "Si" : "No"}
    className={classes.secondaryChip}
  /> */}
          {item.product.factureCreated ? "Si" : "No"}
        </StyledTableCell>
      </StyleTableRow>
      {item.product.chip && (
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
            <Collapse
              in={openCollapsible.open && openCollapsible.index === i}
              timeout="auto"
              unmountOnExit
            >
              <Table size="medium" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">
                      # de teléfono
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <StyledTableCell align="center">
                      {item.product.chip.telephone}
                    </StyledTableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </Fragment>
  );
};

export default SellRow;
